import { FC, ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router';

import { isConstruction } from 'config';

import arrowLeftIcon from 'assets/vectors/arrow-left.svg';
import arrowBackIcon from 'assets/vectors/arrow-back.svg';
import { StyledBackButton } from './styled';

type Props = {
  children?: ReactNode;
  backUrl?: string;
  onClick?: () => void;
};

const BackButton: FC<Props> = ({ children, backUrl, onClick }) => {
  const navigate = useNavigate();

  // Go back
  const onBackClick = useCallback(() => {
    if (onClick) {
      return onClick();
    }
    if (backUrl) {
      return navigate(backUrl);
    }
    return navigate(-1);
  }, [navigate, onClick, backUrl]);

  return (
    <StyledBackButton onClick={onBackClick}>
      <img src={isConstruction ? arrowBackIcon : arrowLeftIcon} alt="Back" />
      {children}
    </StyledBackButton>
  );
};

export default BackButton;
